import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import { TITLE, SUB_TITLE} from "./CloudOpsServicesSpecializationConstants";


// Images
import apps from '../../../assets/img/partnerPortal/appDeveloper/apps.png';
import securityAnalytics from '../../../assets/img/partnerPortal/appDeveloper/security analytics.png';
import scalability from '../../../assets/img/partnerPortal/appDeveloper/scalability.png';
import lightBulbWithGear from '../../../assets/img/partnerPortal/appDeveloper/light-bulb-with-gear.png';
import collaboration from '../../../assets/img/partnerPortal/appDeveloper/cross-team-collaboration.png';
import grail from '../../../assets/img/partnerPortal/appDeveloper/grail.png';
import appDeveloperBackground from '../../../assets/img/partnerPortal/appDeveloper/fullWaveApp.png';
import checkmark from '../../../assets/img/partnerPortal/welcomeAccenture/checkmark-small.svg';
import checkmarWhite from '../../../assets/img/partnerPortal/appDeveloper/checkmark-white.svg';
import developerPortal from '../../../assets/img/partnerPortal/appDeveloper/developerPortal.png';
import developerForum from '../../../assets/img/partnerPortal/appDeveloper/developerForum.png';
import serviceEndorsement from '../../../assets/img/partnerPortal/appDeveloper/serviceEndorsement.png';
import cloudOps from '../../../assets/img/partnerPortal/appDeveloper/cloudOps.png';
import cloudOpsBadge from '../../../assets/img/partnerPortal/appDeveloper/cloudOps_badge.png';


// Scss
import '../../../assets/css/partnerPortal/appDeveloper.scss';
import '../../../assets/css/partnerPortal/sales.scss';
import '../../../assets/css/partnerPortal/welcome.scss';
import '../../../assets/css/partnerProgram.scss';


import Image from "react-bootstrap/Image";
import ButtonArrow from "../../../components/ButtonArrow";
import TitleSubTitleCenter from "../../../components/TitleSubTitleCenter";
import ContentBlock from "../../../components/ContentBlock";

function CloudOpsServicesSpecialization() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  return (
    <>
        <div className="mb-3">
            <BannerOne bannerImage={appDeveloperBackground} title={TITLE} hasNoButton={true} subTitle={SUB_TITLE}  />
            <div className="containerAll">
                <TitleSubTitleCenter sectionWidth="width80" title={"Build and develop unique offerings, transforming the way customers operate through automation and integration"} 
                    subTitle={"Most organizations are running on complex, multicloud, and dynamic environments which makes problem detection and remediation more challenging than ever. "+ 
                                "As a result, organizations need automated ways to deploy and configure Dynatrace and have Dynatrace automatically detect and " +
                                "remediate incidents, as well as maintaining an accurate and up to date CMDB which lies at the heart of any IT Service Management platform, all in real-time."} />
                 <div className="productSection w-100 mt-4 mb-5">
                    <div className="d-flex flex-column justify-content-center align-items-start" >
                        <Image src={cloudOpsBadge}  width={"100%"} />
                    </div>
                    <div className="productCheckPoint">
                        <div className="contactGeneral fontWeight400 fontSize18">
                            Through this CloudOps Specialization, learn how to deploy Dynatrace in an automated way within these environments and how to 
                            integrate and automate incident resolution with ITSM platforms and achieve Service Level Objectives.
                                <br></br><br></br>
                                <div><b>You’ll learn how to:</b></div>
                        </div>
                        <div className="productItem mb-3 mt-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Automatically deploy Dynatrace OneAgents
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Track resiliency of systems with SLOs
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Employ a GitOps approach to Observability via Configuration as Code
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Enrich Dynatrace Smartscape with business context
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                            Automatically remediate problems
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="w-100 mt-5 d-flex align-items-center flex-column">
                    <div className="introframeHeader width80 mx-auto">
                        Combine your expertise to automate your customers’ offerings through:
                    </div>
                    <div className="d-flex align-items-start w-100">
                    <div className="cardCol mt-5">
                            <img src={scalability} alt='...'  />
                            <div className="cardColText">Incident ticketing</div>
                            <div className="cardColSubText">Open a ticket, understand the root-cause, and route to the correct team for resolution. Fully automated.</div>
                        </div>
                        <div className="cardCol mt-5">
                            <img src={lightBulbWithGear} alt='...'  />
                            <div className="cardColText">Automated closed loop remediation</div>
                            <div className="cardColSubText">Resolve an issue, validate the return to normal and automate the closing of the ticket, automatically with Dynatrace.</div>
                        </div>
                        <div className="cardCol mt-5">
                            <img src={securityAnalytics} alt='...'  />
                            <div className="cardColText">Automatically populate the CMDB in dynamic multicloud environments</div>
                            <div className="cardColSubText">Drive faster mean time to identification, repair, remediation, and improved customers SLAs and SLOs.</div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="d-flex flex-column align-items-start mt-5 margin96Botton">
                <div className="d-flex flex-column align-items-center waveImage w-100">
                    <div className="displayFlex align-items-center justify-content-center width67 m-auto ">
                        <div className="d-flex flex-column align-items-center justify-content-center width40 ">
                            <div className="d-flex align-items-start " >
                                <div className="textStyle">What’s in it for you?</div>
                            </div> 
                        </div>
                        <div className="d-flex flex-column align-items-center justify-content-center width55 ">
                            <div className="productItem mb-4">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                Rapidly build customer offerings for your users
                                </div>
                            </div>
                            <div className="productItem mb-4">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                    Certified by a market leader, validating customer satisfaction
                                </div>
                            </div>
                            <div className="productItem mb-3">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                    Elevate and differentiate your expertise in the market
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5">
                <ContentBlock image={cloudOps} sectionWidth="width64" frameTitle={"Pre-requisites to get started"} 
                                sectionOneText={<div className="mb-2">- <b>Individuals</b> must hold their Services Observability Certification.</div>}
                                sectionTwoText={<div>- <b>Organizational Endorsement</b> is achieved by having <b>four Observability Services Certified Individuals, two CloudOps Specialized Individuals, and two referenceable customers.</b></div>}  />
            </div>
            

            <div className="d-flex flex-column align-items-start margin96Botton mt-5 ">
                <div className="d-flex flex-column align-items-center justify-content-center bannerAppDeveloper width67 m-auto">
                    <div className="d-flex flex-column align-items-center width63">
                        <div className="d-flex align-items-stretch mb-4">
                            <div className="textStyle">Ready to get started?</div>
                        </div>
                        <div className="d-flex align-items-center align-self-stretch mb-3 ">
                            <div className="subTextBannerStyle text-center">
                            If you're ready to become a specialist in CloudOps, head to Dynatrace University through the link below to get started.

                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center align-self-stretch ">
                            <a href={"https://university.dynatrace.com/ondemand/course/40352?content=overview"} target="_blank" className="w-100 d-flex justify-content-center"  >
                                <div className="d-flex align-items-center justify-content-center width39 buttonBackground">
                                    <div className="buttonLettersStyle buttonBlack">Get started</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-column align-items-center width67 mx-auto ">
                <div className="d-flex flex-column align-items-center width63 mb-5  ">
                    <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto">Resources</div>
                </div>
                <div className="align-items-start displayFlex">
                    <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ml-3">
                        <img src={developerPortal} width={"100%"} />
                        <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                            <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                                <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">AppDeveloper Specialization</div>
                                <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">Tailor and extend Dynatrace to the business needs of your customers.
                                </div>
                            </div>
                            <ButtonArrow link={"https://partners.dynatrace.com/#/page/app-developer"} buttonName={"Learn More"} width="15%" />

                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ">
                        <img src={developerForum} width={"100%"} />
                        <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                            <div className="d-flex flex-column align-items-center align-self-stretch">
                                <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">Developer Forum</div>
                                <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                                    Share knowledge, connect with others, and explore the best practices when creating apps on Dynatrace.
                                </div>
                            </div>
                            <ButtonArrow link={"https://dt-url.net/devforum"} buttonName={"Learn More"} width="15%" />

                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center cardBackground width31 ">
                        <img src={serviceEndorsement} width={"100%"} />
                        <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                            <div className="d-flex flex-column align-items-center align-self-stretch">
                                <div className="d-flex align-items-start align-self-stretch  cardTitleApp mb-2">Service Endorsement<br></br> Program</div>
                                <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                                    Find out more about the program and how you can get involved.
                                </div>
                            </div>
                            <ButtonArrow link={"https://partners.dynatrace.com/#/page/service_endorsement_pro"} buttonName={"Learn More"} width="15%" />

                        </div>
                    </div>
                </div>
            </div>


        </div >
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default CloudOpsServicesSpecialization;

